import * as Yup from "yup";

export function initialValues(sim = null) {
  return {
    title: sim?.title ?? "",
    description: sim?.description ?? "",
    idServer: sim?.idServer ?? "",
    // Si en BD guardas array en "data", lo mostramos como CSV en la UI:
    data: Array.isArray(sim?.data) ? sim.data.join(",") : (sim?.data ?? ""),
    // tag es string en BD; si no existe, cadena vacía
    tag: sim?.tag ?? "",
    // Miniatura actual (solo visual)
    miniature: sim?.miniature ?? "",
    // Fichero nuevo (si el usuario lo cambia)
    miniatureFile: null,
  };
}

export function validationSchema() {
  return Yup.object({
    title: Yup.string().trim().required("Título requerido"),
    description: Yup.string().trim().required("Descripción requerida"),
    idServer: Yup.string().trim().nullable(),
    data: Yup.string().trim().nullable(),
    // tag es opcional; si lo quieres limitar, añade reglas:
    tag: Yup.string().trim().nullable(),
  });
}
